import { render, staticRenderFns } from "./SelectMemberGroupModal.vue?vue&type=template&id=cd1bacb4&"
import script from "./SelectMemberGroupModal.vue?vue&type=script&lang=ts&"
export * from "./SelectMemberGroupModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports